import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  AddTextBottom,
  AddTextTop,
  ColorButtonsWrapper,
  CountLength,
  ErrorsContainer,
  Left,
  LeftContent,
  LocalPickerWrapper,
  SettingsLabel
} from "../styles";
import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, CommonLabelText } from "@brg/ui";
import { ProjectEditPageGridLabel } from "shared/components/ProjectEditPageGrid";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import { AuthorT } from "shared/pages/projectEdit/types";
import ColorPicker from "../../ColorPicker";
import { BilingWrapper, ColumnLabelGroup, ErrorItem, ProjectEditGrid, RequiredErrorMsg } from "shared/pages/projectEdit/styles";
import { setProjectTitleByLang } from "shared/pages/projectEdit/helpers";
import { AppTester } from "supporting";
import { Checkbox, DropdownWrapper, INIT_ADDITIONAL_CONTENT } from "../PresentatitonBlock";
import { LabelRedStar } from "shared/pages/designerEditView/styles";
import { useTheme } from "styled-components";
import { IAddProjectCoverContent } from "../types/AdditionalContentType";
import { Lang } from "@brg/api";
import ProjectTitleInput from "shared/pages/projectEdit/fields/ProjectTitleInput";
import { useController, useFormContext } from "react-hook-form";
import { CommonCheckbox } from "shared/components/CommonCheckbox/CommonCheckbox";

const BG_COLORS = [
  { label: 'black', value: '#000000' },
  { label: 'white', value: '#fff' }
]

interface ICoverProps {
  vTYPE: string;
  errorsArray?: string[];
  coAuthors?: AuthorT[];
  titleIsHidden?: boolean;
  projectInfoIsHidden?: boolean;
  errorProjectFill?: boolean;
  isBilingual?: boolean;
  longReadLength?: number;
  toggleHideTitle?: (e: any) => void;
  toggleHideInfo?: (e: any) => void;
  onTitlePositionChange?: (pos: string) => void;
  titlePosition?: string;
  onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
}

export const CoverSettingsBlock: FC<ICoverProps> = ({
  vTYPE,
  errorsArray = [],
  projectInfoIsHidden,
  isBilingual,
  errorProjectFill,
  longReadLength,
  toggleHideInfo,
  onTitlePositionChange,
  titlePosition,
}) => {
  const { t, i18n: { language } } = useTranslation();
  const isMobile = useIsMobile();
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const isGeograffee = AppTester.isGeograffee();
  const isProDeziiign = AppTester.isProDeziiign();
  const theme = useTheme();
  const inputRef = useRef(null);
  const [isAutoFocus, setIsAutoFocus] = useState(false);
  const [key, setKey] = useState(1);
  const [postTextPos, setPostTextPos] = useState(titlePosition || '')
  const { field: { value: additionalContent, onChange: onSetAddContent } } = useController({ name: 'additionalContent' });

  const { title = {}, subtitle = {}, button = {}, anchors = {}, annotation = {} } = useMemo(
    () => (additionalContent || {}), [additionalContent])

  const translatedBgColors = useMemo(
    () => (BG_COLORS?.map(
      (i) => ({ ...i, label: t(`project_edit.settings_block.labels.${i.label}`) })))
    , [t])

  const defaultBgColor = useMemo(
    () => (translatedBgColors?.find((i) => i?.value === button?.color))
    , [button?.color, translatedBgColors])


  //to-do заменить обработчики
  const onTitleChange = useCallback((ev: any) => {
    const data = {
      title: {
        ...additionalContent?.title, text:
          setProjectTitleByLang(
            isBilingual || false,
            title.text,
            language,
            ev?.target?.value
          )
      },
      subtitle,
      button,
      anchors,
      annotation
    };

    onSetAddContent && onSetAddContent(data)
  }, [title, subtitle, button, language, anchors, annotation, onSetAddContent, isBilingual])

  const onSubtitleChange = useCallback((ev: any) => {
    const data = {
      title,
      subtitle: {
        ...subtitle, text:
          setProjectTitleByLang(
            isBilingual || false,
            subtitle.text,
            language,
            ev?.target?.value
          )
      },
      button,
      anchors,
      annotation
    };

    onSetAddContent && onSetAddContent(data)
  }, [subtitle, title, button, annotation, language, isBilingual, onSetAddContent])

  const onButtonChange = useCallback((ev: any, field: string) => {
    const isHref = field === 'href';

    const data = {
      title,
      subtitle,
      button: {
        ...button, [field]: isHref ? ev?.target?.value :
          setProjectTitleByLang(
            isBilingual || false,
            // @ts-ignore
            button?.[field],
            language,
            ev?.target?.value
          )
      },
      anchors,
      annotation
    };

    onSetAddContent && onSetAddContent(data)
  }, [button, title, subtitle, anchors, annotation, onSetAddContent, language, isBilingual])

  const onToggleButtonVisible = useCallback((field: string) => {
    const data = { title, subtitle, button };

    if (['title', 'subtitle']?.includes(field)) {
      onSetAddContent && onSetAddContent({
        title: { ...title, visible: !title?.visible },
        subtitle: { ...subtitle, visible: !subtitle?.visible },
        button,
        anchors,
        annotation
      })
      return;
    }

    onSetAddContent && onSetAddContent({
      ...data,
      [field]: {
        // @ts-ignore
        ...data[field as keyof IAddProjectCoverContent]
        // @ts-ignore
        , visible: !data[field as keyof IAddProjectCoverContent].visible
      }
    })
  }, [title, button, subtitle, anchors, annotation, onSetAddContent])

  const onLocalColorChange = useCallback((color: string, k: any) => {
    const data = { title, subtitle, button, anchors };

    if (k === 'button') {
      data.button = { ...data.button, bgColor: color };
    } else if (k === 'button-color') {
      data.button = { ...data.button, color: color };
    } else {
      // @ts-ignore
      data[k] = { ...data[k], color: color };
    }
    onSetAddContent && onSetAddContent({ ...data });
  }, [title, button, subtitle, onSetAddContent]);

  const onButtonBgChange = useCallback((color: string) => {
    const data = { title, subtitle, button, anchors, annotation };

    onSetAddContent && onSetAddContent({
      ...data, button: { ...button, color }
    })
  }, [title, button, subtitle, anchors, annotation, onSetAddContent])




  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsAutoFocus(true);
        } else {
          setIsAutoFocus(false);
        }
      },
      { threshold: 0.1 }
    );

    if (inputRef.current) {
      observer.observe(inputRef.current);
    }

    return () => {
      if (inputRef.current) {
        observer.unobserve(inputRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, [isAutoFocus]);

  useEffect(() => {
    onTitlePositionChange && onTitlePositionChange(postTextPos);
  }, [postTextPos]);

  const CoverInputs = useMemo(() => (
    <FlexBox direction="column" directionMobile="column" gy={24}>

      <ProjectTitleInput
        type={INPUT_TYPES.counter}
        orientation="column"
        label={t('project_edit.settings_block.labels.title')}
        placeholder={t('project_edit.type_something_new')}
        onChange={onTitleChange}
        required
        key={key}
      />

      {/* <CommonInput 
              type={INPUT_TYPES.counter}
              label={t('project_edit.settings_block.labels.title')}
              orientation="column"
              placeholder={t('project_edit.type_something_new')}
              maxLength={75}
              value={Lang(title?.text, language)}
              onChange={onTitleChange}
              required
              key={key}
            /> */}

      <CommonInput
        type={INPUT_TYPES.counter}
        placeholder={t('project_edit.type_something_new')}
        label={t('project_edit.settings_block.labels.subtitle')}
        orientation="column"
        maxLength={100}
        value={Lang(subtitle?.text, language)}
        onChange={onSubtitleChange}
      />
    </FlexBox>
  ), [title, subtitle, is743, t, language, onTitleChange, isMobile, onSubtitleChange, isAutoFocus, key])


  const TextPosButtons = useMemo(() => {
    return <FlexBox direction="column">
      <ColumnLabelGroup>
        <CommonLabelText>{t('project_edit.settings_block.labels.position_button')}</CommonLabelText>
        <FlexBox gx={24}>
          <AddTextBottom
            active={postTextPos === 'default'}
            onClick={() => setPostTextPos('default')}
            current={titlePosition === 'big-caption'}
          >
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.5H29C29.4729 6.5 30 6.92504 30 7.63043V25.3696C30 26.075 29.4729 26.5 29 26.5H3C2.52708 26.5 2 26.075 2 25.3696V7.63043C2 6.92504 2.52708 6.5 3 6.5ZM0 7.63043C0 5.90154 1.34315 4.5 3 4.5H29C30.6569 4.5 32 5.90154 32 7.63043V25.3696C32 27.0985 30.6569 28.5 29 28.5H3C1.34315 28.5 0 27.0985 0 25.3696V7.63043ZM6 9.5C5.44772 9.5 5 9.94772 5 10.5V12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5V10.5C19 9.94772 18.5523 9.5 18 9.5H6Z" fill="#909090"/>
            </svg>
          </AddTextBottom>
          <AddTextTop
            active={postTextPos === 'default-top'}
            onClick={() => setPostTextPos('default-top')}
            current={titlePosition === 'big-caption'}
          >
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.5H29C29.4729 6.5 30 6.92504 30 7.63043V25.3696C30 26.075 29.4729 26.5 29 26.5H3C2.52708 26.5 2 26.075 2 25.3696V7.63043C2 6.92504 2.52708 6.5 3 6.5ZM0 7.63043C0 5.90154 1.34315 4.5 3 4.5H29C30.6569 4.5 32 5.90154 32 7.63043V25.3696C32 27.0985 30.6569 28.5 29 28.5H3C1.34315 28.5 0 27.0985 0 25.3696V7.63043ZM6 9.5C5.44772 9.5 5 9.94772 5 10.5V12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5V10.5C19 9.94772 18.5523 9.5 18 9.5H6Z" fill="#909090"/>
            </svg>
          </AddTextTop>
        </FlexBox>
      </ColumnLabelGroup>
    </FlexBox>
  }, [is743, postTextPos, t, titlePosition])

  const ButtonInputs = useMemo(() => {

    if (!button?.visible) {
      return <FlexBox>{TextPosButtons}</FlexBox>
    }

    return (
      <ProjectEditGrid>
        <CommonInput
          value={Lang(button?.text, language)}
          type={INPUT_TYPES.counter}
          onChange={(ev: any) => onButtonChange(ev, 'text')}
          placeholder={t('project_edit.type_something_new')}
          label={t('project_edit.settings_block.labels.text_on_button')}
          orientation="column"
          maxLength={35}
        />
        <CommonInput
          value={button.href}
          type={INPUT_TYPES.counter}
          maxLength={100}
          onChange={(ev: any) => onButtonChange(ev, 'href')}
          placeholder={t('project_edit.type_something_new')}
          label={t('project_edit.settings_block.labels.link_on_button')}
          orientation="column"
        />
        {TextPosButtons}
        {!isProDeziiign && (
          <ColumnLabelGroup>
            <CommonLabelText>{t(`project_edit.settings_block.labels.button_bg_color`)}</CommonLabelText>
            <DropdownWrapper directionMobile="column" width={'100%'} widthMobile={'100%'}>
              <ProjectEditPageGridInput isTeamEdit isColumns>
                <Input.Dropdown
                  value={defaultBgColor}
                  onChange={(option: any) => {
                    onButtonBgChange(option.value)
                  }}
                  options={translatedBgColors}
                />
              </ProjectEditPageGridInput>
            </DropdownWrapper>
          </ColumnLabelGroup>
        )}
      </ProjectEditGrid>
    )
  }, [button, is743, translatedBgColors, defaultBgColor, t, language, onButtonChange, onButtonBgChange, postTextPos])

  const VisibleSettings = useMemo(() => (
    <FlexBox
      style={{ display: is743 ? 'none' : 'flex' }}
      direction='column'
      directionMobile="column"
      gy={24}
    >
      <BilingWrapper isPresentation>
        <CommonCheckbox
          label={t('project_edit.hide_title')}
          checked={!title?.visible}
          dark={!isGeograffee}
          onClick={() => onToggleButtonVisible('title')}
        />
      </BilingWrapper>
      {isProDeziiign && <BilingWrapper isPresentation>
        <CommonCheckbox
          label={t('project_edit.hide_project_info')}
          checked={!!projectInfoIsHidden}
          dark={!isGeograffee}
          hintText={t('project_edit.hide_project_info_hint')}
          onClick={() => {
            toggleHideInfo?.((prev: boolean) => !prev);
          }}
        />
      </BilingWrapper>}
      <BilingWrapper>
        <CommonCheckbox
          label={t('project_edit.settings_block.labels.button')}
          checked={button?.visible}
          dark={!isGeograffee}
          onClick={() => onToggleButtonVisible('button')}
        />
      </BilingWrapper>
    </FlexBox>
  ), [button, isGeograffee, projectInfoIsHidden, title, t, onToggleButtonVisible, is743])

  const LocalPickers = useMemo(() => {
    return (
      <LocalPickerWrapper direction="column" directionMobile="column">
        {VisibleSettings}
        {ButtonInputs}
        <ColorButtonsWrapper isProDeziiign={isProDeziiign}>
          {/*@ts-ignore*/}
          {!!additionalContent && Object.entries(additionalContent)?.filter(([k, v]) => k !== 'anchors' && k !== 'annotation')?.map(([k, v]) => {
            //@ts-ignore
            if (k === 'anchors' || (k === 'button' && !v?.visible)) {
              return false;
            }
            if (isProDeziiign) {
              return (
                <React.Fragment key={k}>
                  <ColorPicker
                    isShort
                    //@ts-ignore 
                    value={k === 'button' ? v?.bgColor : v?.color}
                    onChange={(val: string) => onLocalColorChange(val, k)}
                    label={t(`project_edit.settings_block.picker_labels.${k}`)}
                    isProDeziiign={isProDeziiign}
                    customAlignItems="flex-start"
                  />
                  {k === 'button' && (
                    <ColorPicker
                      isShort
                      isButtonColor
                      value={v?.color}
                      onChange={(val: string) => onLocalColorChange(val, `${k}-color`)}
                      label={t(`project_edit.settings_block.labels.button_bg_color`)}
                      isProDeziiign={isProDeziiign}
                      customAlignItems="flex-start"
                    />
                  )}
                </React.Fragment>

              )
            }
            return (
              <ColorPicker
                isShort
                //@ts-ignore 
                value={k === 'button' ? v?.bgColor : v?.color}
                onChange={(val: string) => onLocalColorChange(val, k)}
                label={t(`project_edit.settings_block.picker_labels.${k}`)}
              />
            )
          }
          )}
        </ColorButtonsWrapper>
      </LocalPickerWrapper>
    )
  }, [additionalContent, VisibleSettings, ButtonInputs, t, onLocalColorChange])

  const ErrorsBlock = useMemo(() => {

    if (errorsArray) {
      return (
        <FlexBox style={{ order: is743 ? 1 : 0 }} className="mobile-block-5">
          <ErrorsContainer>
            {(errorProjectFill || longReadLength === 0) && (
              <FlexBox direction="column" directionMobile='column' gy={16} offsetRight={32} offsetRightMobile={is743 ? 0 : 32}>
                <ErrorItem
                  color={theme.projectEdit.textTips}
                  direction="column"
                  directionMobile="column"
                >
                  <ul>
                    {errorsArray.slice(0, -1).map((error) => (
                      <li>
                        <FlexBox direction='row'>
                          <span style={{ marginRight: 8 }}>{`—`}</span>
                          <span>{`${error}`}</span>
                        </FlexBox>
                      </li>
                    ))}
                  </ul>
                </ErrorItem>
              </FlexBox>
            )}
            {!!errorsArray?.length && (
              <FlexBox direction='row' directionMobile='row'>
                <LabelRedStar style={{ marginLeft: 0 }}>*</LabelRedStar>
                <RequiredErrorMsg>{errorsArray[errorsArray.length - 1]}</RequiredErrorMsg>
              </FlexBox>
            )}
          </ErrorsContainer>
        </FlexBox>
      )
    }
  }, [errorsArray, errorProjectFill, longReadLength, is743, theme])

  return (
    <Left vtype={vTYPE}>
      <LeftContent>
        <SettingsLabel>{t('project_edit.cover_title')}</SettingsLabel>
        {CoverInputs}
        {LocalPickers}
        {ErrorsBlock}
      </LeftContent>
    </Left>
  )
}import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  AddTextBottom,
  AddTextTop,
  ColorButtonsWrapper,
  CountLength,
  ErrorsContainer,
  Left,
  LeftContent,
  LocalPickerWrapper,
  SettingsLabel
} from "../styles";
import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, CommonLabelText } from "@brg/ui";
import { ProjectEditPageGridLabel } from "shared/components/ProjectEditPageGrid";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import { AuthorT } from "shared/pages/projectEdit/types";
import ColorPicker from "../../ColorPicker";
import { BilingWrapper, ColumnLabelGroup, ErrorItem, ProjectEditGrid, RequiredErrorMsg } from "shared/pages/projectEdit/styles";
import { setProjectTitleByLang } from "shared/pages/projectEdit/helpers";
import { AppTester } from "supporting";
import { Checkbox, DropdownWrapper, INIT_ADDITIONAL_CONTENT } from "../PresentatitonBlock";
import { LabelRedStar } from "shared/pages/designerEditView/styles";
import { useTheme } from "styled-components";
import { IAddProjectCoverContent } from "../types/AdditionalContentType";
import { Lang } from "@brg/api";
import ProjectTitleInput from "shared/pages/projectEdit/fields/ProjectTitleInput";
import { useController, useFormContext } from "react-hook-form";
import { CommonCheckbox } from "shared/components/CommonCheckbox/CommonCheckbox";

const BG_COLORS = [
  { label: 'black', value: '#000000' },
  { label: 'white', value: '#fff' }
]

interface ICoverProps {
  vTYPE: string;
  errorsArray?: string[];
  coAuthors?: AuthorT[];
  titleIsHidden?: boolean;
  projectInfoIsHidden?: boolean;
  errorProjectFill?: boolean;
  isBilingual?: boolean;
  longReadLength?: number;
  toggleHideTitle?: (e: any) => void;
  toggleHideInfo?: (e: any) => void;
  onTitlePositionChange?: (pos: string) => void;
  titlePosition?: string;
  onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
}

export const CoverSettingsBlock: FC<ICoverProps> = ({
  vTYPE,
  errorsArray = [],
  projectInfoIsHidden,
  isBilingual,
  errorProjectFill,
  longReadLength,
  toggleHideInfo,
  onTitlePositionChange,
  titlePosition,
}) => {
  const { t, i18n: { language } } = useTranslation();
  const isMobile = useIsMobile();
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const isGeograffee = AppTester.isGeograffee();
  const isProDeziiign = AppTester.isProDeziiign();
  const theme = useTheme();
  const inputRef = useRef(null);
  const [isAutoFocus, setIsAutoFocus] = useState(false);
  const [key, setKey] = useState(1);
  const [postTextPos, setPostTextPos] = useState(titlePosition || '')
  const { field: { value: additionalContent, onChange: onSetAddContent } } = useController({ name: 'additionalContent' });

  const { title = {}, subtitle = {}, button = {}, anchors = {}, annotation = {} } = useMemo(
    () => (additionalContent || {}), [additionalContent])

  const translatedBgColors = useMemo(
    () => (BG_COLORS?.map(
      (i) => ({ ...i, label: t(`project_edit.settings_block.labels.${i.label}`) })))
    , [t])

  const defaultBgColor = useMemo(
    () => (translatedBgColors?.find((i) => i?.value === button?.color))
    , [button?.color, translatedBgColors])


  //to-do заменить обработчики
  const onTitleChange = useCallback((ev: any) => {
    const data = {
      title: {
        ...additionalContent?.title, text:
          setProjectTitleByLang(
            isBilingual || false,
            title.text,
            language,
            ev?.target?.value
          )
      },
      subtitle,
      button,
      anchors,
      annotation
    };

    onSetAddContent && onSetAddContent(data)
  }, [title, subtitle, button, language, anchors, annotation, onSetAddContent, isBilingual])

  const onSubtitleChange = useCallback((ev: any) => {
    const data = {
      title,
      subtitle: {
        ...subtitle, text:
          setProjectTitleByLang(
            isBilingual || false,
            subtitle.text,
            language,
            ev?.target?.value
          )
      },
      button,
      anchors,
      annotation
    };

    onSetAddContent && onSetAddContent(data)
  }, [subtitle, title, button, annotation, language, isBilingual, onSetAddContent])

  const onButtonChange = useCallback((ev: any, field: string) => {
    const isHref = field === 'href';

    const data = {
      title,
      subtitle,
      button: {
        ...button, [field]: isHref ? ev?.target?.value :
          setProjectTitleByLang(
            isBilingual || false,
            // @ts-ignore
            button?.[field],
            language,
            ev?.target?.value
          )
      },
      anchors,
      annotation
    };

    onSetAddContent && onSetAddContent(data)
  }, [button, title, subtitle, anchors, annotation, onSetAddContent, language, isBilingual])

  const onToggleButtonVisible = useCallback((field: string) => {
    const data = { title, subtitle, button };

    if (['title', 'subtitle']?.includes(field)) {
      onSetAddContent && onSetAddContent({
        title: { ...title, visible: !title?.visible },
        subtitle: { ...subtitle, visible: !subtitle?.visible },
        button,
        anchors,
        annotation
      })
      return;
    }

    onSetAddContent && onSetAddContent({
      ...data,
      [field]: {
        // @ts-ignore
        ...data[field as keyof IAddProjectCoverContent]
        // @ts-ignore
        , visible: !data[field as keyof IAddProjectCoverContent].visible
      }
    })
  }, [title, button, subtitle, anchors, annotation, onSetAddContent])

  const onLocalColorChange = useCallback((color: string, k: any) => {
    const data = { title, subtitle, button, anchors };

    if (k === 'button') {
      data.button = { ...data.button, bgColor: color };
    } else if (k === 'button-color') {
      data.button = { ...data.button, color: color };
    } else {
      // @ts-ignore
      data[k] = { ...data[k], color: color };
    }
    onSetAddContent && onSetAddContent({ ...data });
  }, [title, button, subtitle, onSetAddContent]);

  const onButtonBgChange = useCallback((color: string) => {
    const data = { title, subtitle, button, anchors, annotation };

    onSetAddContent && onSetAddContent({
      ...data, button: { ...button, color }
    })
  }, [title, button, subtitle, anchors, annotation, onSetAddContent])




  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsAutoFocus(true);
        } else {
          setIsAutoFocus(false);
        }
      },
      { threshold: 0.1 }
    );

    if (inputRef.current) {
      observer.observe(inputRef.current);
    }

    return () => {
      if (inputRef.current) {
        observer.unobserve(inputRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, [isAutoFocus]);

  useEffect(() => {
    onTitlePositionChange && onTitlePositionChange(postTextPos);
  }, [postTextPos]);

  const CoverInputs = useMemo(() => (
    <FlexBox direction="column" directionMobile="column" gy={24}>

      <ProjectTitleInput
        type={INPUT_TYPES.counter}
        orientation="column"
        label={t('project_edit.settings_block.labels.title')}
        placeholder={t('project_edit.type_something_new')}
        onChange={onTitleChange}
        required
        key={key}
      />

      {/* <CommonInput 
              type={INPUT_TYPES.counter}
              label={t('project_edit.settings_block.labels.title')}
              orientation="column"
              placeholder={t('project_edit.type_something_new')}
              maxLength={75}
              value={Lang(title?.text, language)}
              onChange={onTitleChange}
              required
              key={key}
            /> */}

      <CommonInput
        type={INPUT_TYPES.counter}
        placeholder={t('project_edit.type_something_new')}
        label={t('project_edit.settings_block.labels.subtitle')}
        orientation="column"
        maxLength={100}
        value={Lang(subtitle?.text, language)}
        onChange={onSubtitleChange}
      />
    </FlexBox>
  ), [title, subtitle, is743, t, language, onTitleChange, isMobile, onSubtitleChange, isAutoFocus, key])


  const TextPosButtons = useMemo(() => {
    return <FlexBox direction="column">
      <ColumnLabelGroup>
        <CommonLabelText>{t('project_edit.settings_block.labels.position_button')}</CommonLabelText>
        <FlexBox gx={24}>
          <AddTextBottom
            active={postTextPos === 'default'}
            onClick={() => setPostTextPos('default')}
            current={titlePosition === 'big-caption'}
          >
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.5H29C29.4729 6.5 30 6.92504 30 7.63043V25.3696C30 26.075 29.4729 26.5 29 26.5H3C2.52708 26.5 2 26.075 2 25.3696V7.63043C2 6.92504 2.52708 6.5 3 6.5ZM0 7.63043C0 5.90154 1.34315 4.5 3 4.5H29C30.6569 4.5 32 5.90154 32 7.63043V25.3696C32 27.0985 30.6569 28.5 29 28.5H3C1.34315 28.5 0 27.0985 0 25.3696V7.63043ZM6 9.5C5.44772 9.5 5 9.94772 5 10.5V12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5V10.5C19 9.94772 18.5523 9.5 18 9.5H6Z" fill="#909090"/>
            </svg>
          </AddTextBottom>
          <AddTextTop
            active={postTextPos === 'default-top'}
            onClick={() => setPostTextPos('default-top')}
            current={titlePosition === 'big-caption'}
          >
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.5H29C29.4729 6.5 30 6.92504 30 7.63043V25.3696C30 26.075 29.4729 26.5 29 26.5H3C2.52708 26.5 2 26.075 2 25.3696V7.63043C2 6.92504 2.52708 6.5 3 6.5ZM0 7.63043C0 5.90154 1.34315 4.5 3 4.5H29C30.6569 4.5 32 5.90154 32 7.63043V25.3696C32 27.0985 30.6569 28.5 29 28.5H3C1.34315 28.5 0 27.0985 0 25.3696V7.63043ZM6 9.5C5.44772 9.5 5 9.94772 5 10.5V12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5V10.5C19 9.94772 18.5523 9.5 18 9.5H6Z" fill="#909090"/>
            </svg>
          </AddTextTop>
        </FlexBox>
      </ColumnLabelGroup>
    </FlexBox>
  }, [is743, postTextPos, t, titlePosition])

  const ButtonInputs = useMemo(() => {

    if (!button?.visible) {
      return <FlexBox>{TextPosButtons}</FlexBox>
    }

    return (
      <ProjectEditGrid>
        <CommonInput
          value={Lang(button?.text, language)}
          type={INPUT_TYPES.counter}
          onChange={(ev: any) => onButtonChange(ev, 'text')}
          placeholder={t('project_edit.type_something_new')}
          label={t('project_edit.settings_block.labels.text_on_button')}
          orientation="column"
          maxLength={35}
        />
        <CommonInput
          value={button.href}
          type={INPUT_TYPES.counter}
          maxLength={100}
          onChange={(ev: any) => onButtonChange(ev, 'href')}
          placeholder={t('project_edit.type_something_new')}
          label={t('project_edit.settings_block.labels.link_on_button')}
          orientation="column"
        />
        {TextPosButtons}
        {!isProDeziiign && (
          <ColumnLabelGroup>
            <CommonLabelText>{t(`project_edit.settings_block.labels.button_bg_color`)}</CommonLabelText>
            <DropdownWrapper directionMobile="column" width={'100%'} widthMobile={'100%'}>
              <ProjectEditPageGridInput isTeamEdit isColumns>
                <Input.Dropdown
                  value={defaultBgColor}
                  onChange={(option: any) => {
                    onButtonBgChange(option.value)
                  }}
                  options={translatedBgColors}
                />
              </ProjectEditPageGridInput>
            </DropdownWrapper>
          </ColumnLabelGroup>
        )}
      </ProjectEditGrid>
    )
  }, [button, is743, translatedBgColors, defaultBgColor, t, language, onButtonChange, onButtonBgChange, postTextPos])

  const VisibleSettings = useMemo(() => (
    <FlexBox
      style={{ display: is743 ? 'none' : 'flex' }}
      direction='column'
      directionMobile="column"
      gy={24}
    >
      <BilingWrapper isPresentation>
        <CommonCheckbox
          label={t('project_edit.hide_title')}
          checked={!title?.visible}
          dark={!isGeograffee}
          onClick={() => onToggleButtonVisible('title')}
        />
      </BilingWrapper>
      {isProDeziiign && <BilingWrapper isPresentation>
        <CommonCheckbox
          label={t('project_edit.hide_project_info')}
          checked={!!projectInfoIsHidden}
          dark={!isGeograffee}
          hintText={t('project_edit.hide_project_info_hint')}
          onClick={() => {
            toggleHideInfo?.((prev: boolean) => !prev);
          }}
        />
      </BilingWrapper>}
      <BilingWrapper>
        <CommonCheckbox
          label={t('project_edit.settings_block.labels.button')}
          checked={button?.visible}
          dark={!isGeograffee}
          onClick={() => onToggleButtonVisible('button')}
        />
      </BilingWrapper>
    </FlexBox>
  ), [button, isGeograffee, projectInfoIsHidden, title, t, onToggleButtonVisible, is743])

  const LocalPickers = useMemo(() => {
    return (
      <LocalPickerWrapper direction="column" directionMobile="column">
        {VisibleSettings}
        {ButtonInputs}
        <ColorButtonsWrapper isProDeziiign={isProDeziiign}>
          {/*@ts-ignore*/}
          {!!additionalContent && Object.entries(additionalContent)?.filter(([k, v]) => k !== 'anchors' && k !== 'annotation')?.map(([k, v]) => {
            //@ts-ignore
            if (k === 'anchors' || (k === 'button' && !v?.visible)) {
              return false;
            }
            if (isProDeziiign) {
              return (
                <React.Fragment key={k}>
                  <ColorPicker
                    isShort
                    //@ts-ignore 
                    value={k === 'button' ? v?.bgColor : v?.color}
                    onChange={(val: string) => onLocalColorChange(val, k)}
                    label={t(`project_edit.settings_block.picker_labels.${k}`)}
                    isProDeziiign={isProDeziiign}
                    customAlignItems="flex-start"
                  />
                  {k === 'button' && (
                    <ColorPicker
                      isShort
                      isButtonColor
                      value={v?.color}
                      onChange={(val: string) => onLocalColorChange(val, `${k}-color`)}
                      label={t(`project_edit.settings_block.labels.button_bg_color`)}
                      isProDeziiign={isProDeziiign}
                      customAlignItems="flex-start"
                    />
                  )}
                </React.Fragment>

              )
            }
            return (
              <ColorPicker
                isShort
                //@ts-ignore 
                value={k === 'button' ? v?.bgColor : v?.color}
                onChange={(val: string) => onLocalColorChange(val, k)}
                label={t(`project_edit.settings_block.picker_labels.${k}`)}
              />
            )
          }
          )}
        </ColorButtonsWrapper>
      </LocalPickerWrapper>
    )
  }, [additionalContent, VisibleSettings, ButtonInputs, t, onLocalColorChange])

  const ErrorsBlock = useMemo(() => {

    if (errorsArray) {
      return (
        <FlexBox style={{ order: is743 ? 1 : 0 }} className="mobile-block-5">
          <ErrorsContainer>
            {(errorProjectFill || longReadLength === 0) && (
              <FlexBox direction="column" directionMobile='column' gy={16} offsetRight={32} offsetRightMobile={is743 ? 0 : 32}>
                <ErrorItem
                  color={theme.projectEdit.textTips}
                  direction="column"
                  directionMobile="column"
                >
                  <ul>
                    {errorsArray.slice(0, -1).map((error) => (
                      <li>
                        <FlexBox direction='row'>
                          <span style={{ marginRight: 8 }}>{`—`}</span>
                          <span>{`${error}`}</span>
                        </FlexBox>
                      </li>
                    ))}
                  </ul>
                </ErrorItem>
              </FlexBox>
            )}
            {!!errorsArray?.length && (
              <FlexBox direction='row' directionMobile='row'>
                <LabelRedStar style={{ marginLeft: 0 }}>*</LabelRedStar>
                <RequiredErrorMsg>{errorsArray[errorsArray.length - 1]}</RequiredErrorMsg>
              </FlexBox>
            )}
          </ErrorsContainer>
        </FlexBox>
      )
    }
  }, [errorsArray, errorProjectFill, longReadLength, is743, theme])

  return (
    <Left vtype={vTYPE}>
      <LeftContent>
        <SettingsLabel>{t('project_edit.cover_title')}</SettingsLabel>
        {CoverInputs}
        {LocalPickers}
        {ErrorsBlock}
      </LeftContent>
    </Left>
  )
}